import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PlansService, Plan } from '../../services/plans.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CreatePlanModalComponent } from './modals/create-plan-modal.component';
import { EditPlanModalComponent } from './modals/edit-plan-modal.component';
import { InactivePlanPricesModalComponent } from './modals/inactive-plan-prices-modal.component';
import { ConfirmDialogComponent } from '../../shared/components/ConfirmDialogComponent';

@Component({
  selector: 'app-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['./plans.component.scss']
})
export class PlansComponent implements OnInit {
  plans: Plan[] = [];
  page: number = 1;
  search: string = '';
  totalItems: number = 0;
  isFilterApplied: boolean = false;

  constructor(
    private plansService: PlansService,
    private dialog: MatDialog,
    private router: Router,
    private snack: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loadPlans();
  }

  loadPlans(): void {
    this.plansService.getPlans(this.page, this.search).subscribe((response: any) => {
      this.plans = response.data.sort((a: Plan, b: Plan) => {
        if (a.status === 'active' && b.status === 'inactive') return -1;
        if (a.status === 'inactive' && b.status === 'active') return 1;
        return 0;
      });
      this.totalItems = response.total;
    });
  }

  onSearch(): void {
    this.page = 1;
    this.isFilterApplied = this.search.trim() !== '';
    this.loadPlans();
  }

  clearFilters(): void {
    this.search = '';
    this.isFilterApplied = false;
    this.loadPlans();
  }

  openCreatePlanModal(): void {
    const dialogRef = this.dialog.open(CreatePlanModalComponent, { width: '400px' });
    dialogRef.afterClosed().subscribe((result: string) => {
      if (result) {
        this.plansService.createPlan(result).subscribe(() => {
          this.loadPlans();
          this.snack.open('Plano criado com sucesso!', 'OK', { duration: 4000 });
        }, error => {
          this.snack.open('Erro ao criar o plano: ' + error.error.message, 'OK', { duration: 4000 });
        });
      }
    });
  }

  openEditPlanModal(plan: Plan): void {
    const dialogRef = this.dialog.open(EditPlanModalComponent, { width: '400px' });
    dialogRef.componentInstance.planName = plan.name;
    dialogRef.afterClosed().subscribe((result: string) => {
      if (result) {
        this.plansService.updatePlan(plan.id, result).subscribe(() => {
          this.loadPlans();
          this.snack.open('Plano atualizado com sucesso!', 'OK', { duration: 4000 });
        }, error => {
          this.snack.open('Erro ao atualizar o plano: ' + error.error.message, 'OK', { duration: 4000 });
        });
      }
    });
  }

  inactivatePlan(plan: Plan): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { message: 'Deseja realmente inativar este plano?' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.plansService.inactivatePlan(plan.id).subscribe(() => {
          this.loadPlans();
        }, error => {
          this.snack.open('Erro ao inativar o plano: ' + error.error.message, 'OK', { duration: 4000 });
        });
      }
    });
  }

  accessPlan(plan: Plan): void {
    if (plan.status === 'active') {
      this.router.navigate(['/plans', plan.id, 'prices']);
    } else {
      this.dialog.open(InactivePlanPricesModalComponent, {
        width: '600px',
        data: { planId: plan.id, planName: plan.name }
      });
    }
  }

  changePage(newPage: number): void {
    if (newPage < 1) return;
    this.page = newPage;
    this.loadPlans();
  }
}
